import { sharedNumber } from "./constant";

export const englishCharArr = JSON.parse(process.env.REACT_ENGLISH_GATEWAY_SMS_CONFIG);

export const unicodeCharArr = JSON.parse(process.env.REACT_UNICODE_GATEWAY_SMS_CONFIG);

export const resendCounterTime = 180;

export const langRegEx = /^[\x00-\x7F]+$/;

export const optOutMessageSample = process.env.REACT_OPT_OUT_LINK_SAMPLE || "stopsms.co/u######";

export const replyStopMessageSample = "Reply STOP to opt-out";

export const replyLinkMessageSample = process.env.REACT_REPLY_LINK_SAMPLE;

export const mobileRegExp = /^[0-9]{11}$/;

export const countryCodeRegExp = /^61/;

export const fieldRegEx = /{{[a-z- ]*}}/gi;

export const contactFieldSeperatorRegEx = /[,;]/;

export const validAusNumberRegExp = /^(\+?\(61\)|\(\+?61\)|\+?61|\(0[1-9]\)|0[1-9])?( ?-?[0-9]){7,9}$/gm;

export const shortUrlSample = process.env.REACT_SHORT_URL_SAMPLE;

// Australian mobile number validation
// Valid formats:
// - 0478565512 (local with 0)
// - 478565512 (local without 0)
// - 61478565512 (international without 0 after country code)
// - +61478565512 (with + prefix)
// Invalid: 610478565512 (country code + 0 is not allowed)
// export const validAusNumberRegExpDeluxe = /^(?:(?:\+?61(?!0)[ ]?|0)?[4-5](?:[ -]?\d){8})$/gm;
// export const validAusNumberRegExpDeluxe = /^(?:(?:\+?61(?!0)[ ]?|0)?4(?:[ -]?\d){8})$/gm;

export const emailPhoneRegExp = /^(?:\+?(61))? ?(?:\((?=.*\)))?(0?[4])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/gm;

export const emailRegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/gm;

export const contactMaskRegExp = /^(.{3})[^@]+(.{3})/;

export const urlRegExp = /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;

export const googleSheetRegExp = /[(http|https)://]?docs.google.com\/spreadsheets\/d\/[a-zA-Z0-9/_/-]+\//;

export const activeCampUrlRegExp = /^https:\/\/([^.]+)\.activehosted\.com/;

export const validAusNumberRegExpDeluxe = /^(?:\+?(61))? ?(?:\((?=.*\)))?(0?[4])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})$/gm;

export function getFormatedContact(contact) {
  try {
    // remove any symbols in  mobile number
    let mobile = contact.replace(/[^0-9]/g, "");
    // remove any spaces in mobile number
    mobile = mobile.replace(/\s/g, "");
    // remove any leading 0 in mobile number
    mobile = mobile.replace(/^0+/, "");
    // add country code to mobile number
    switch (true) {
      case mobile.length === 9:
        return "61" + mobile;
      default:
        return mobile;
    }
  } catch (err) {
    console.log("contact -> ", contact);
    console.log(err);
    // return '';
  }
}

export function getParsedContact(contact, removeCountryCode = false) {
  if (contact.match(emailRegExp)) return contact;
  let mobile = contact.split(" ").join("");
  mobile = mobile.split("-").join("");
  mobile = mobile.split("+").join("");
  switch (true) {
    case mobile.length === 10:
      if (removeCountryCode) return mobile.split(/0(.+)/)[1];
      return "61" + mobile.split(/0(.+)/)[1];
    case mobile.length === 11:
      if (removeCountryCode) return mobile.split(/61(.+)/)[1];
      return "61" + mobile.split(/61(.+)/)[1];
    case mobile.length === 12:
      if (removeCountryCode) return mobile.split(/610(.+)/)[1];
      return "61" + mobile.split(/610(.+)/)[1];
    default:
      if (removeCountryCode) return mobile;
      return "61" + mobile;
  }
}

export function getFormatedContacts(contacts) {
  return contacts.map(mobileUnformatted => {
    // remove any symbols in  mobile number
    let mobile = mobileUnformatted.replace(/[^0-9]/g, "");
    // remove any spaces in mobile number
    mobile = mobile.replace(/\s/g, "");
    // remove any leading 0 in mobile number
    mobile = mobile.replace(/^0+/, "");
    // add country code to mobile number
    switch (true) {
      case mobile.length === 9:
        return "61" + mobile;
      default:
        return mobile;
    }
  });
}

export function checkSender(value = "", user, messageStore) {
  if (
    user &&
    ((user?.mobileSenders && user?.mobileSenders.includes(value)) || (user?.senders && user?.senders.includes(value)) || user?.mobile === value || user?.countryCode + user?.mobile === value)
  ) {
    return value;
  } else {
    return sharedNumber;
  }
}

/** Compose sender from user's profile default (Campaign / Quick SMS / Conversation). */
export function resolveDefaultComposeSender(user, allSenders = [], isMms = false) {
  const d = user?.defaultSender;
  if (!d || d === sharedNumber) return sharedNumber;
  if (isMms) {
    return user?.mobileSenders?.includes(d) ? d : sharedNumber;
  }
  if (allSenders?.some(s => s.value === d)) return d;
  if (
    user?.mobileSenders?.includes(d) ||
    user?.senders?.includes(d) ||
    user?.personalSenders?.includes(d) ||
    user?.mobile === d ||
    (user?.countryCode && user?.mobile && `${user.countryCode}${user.mobile}` === d)
  ) {
    return d;
  }
  return sharedNumber;
}

export function checkEmailOrPhone(value) {
  function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  function validateOnlyNumbers(phone) {
    return phone.match(/^\d+$/);
  }

  if (validateOnlyNumbers(value)) {
    return { mobile: value };
  }
  if (validateEmail(value)) {
    return { email: value };
  }
  if (!validateOnlyNumbers(value) && !validateEmail(value)) {
    return value;
  }
}

export function messageCounts(msgs, values) {
  let total = 0;
  let unsubscribe = 0;
  let subscribe = 0;

  const findContactById = contactId => {
    if (!Array.isArray(msgs)) return null;

    for (const group of msgs) {
      if (!group.contacts) continue;

      const fullContact = group.contacts.find(c => {
        if (typeof c === "string" && c.includes(":")) {
          return c.split(":")[0] === contactId;
        }
        return c._id === contactId;
      });

      if (fullContact) {
        if (typeof fullContact !== "string" || !fullContact.includes(":")) {
          return fullContact;
        }
      }
    }

    return null;
  };

  const isUnsubscribed = contact => {
    if (typeof contact === "string" && contact.includes(":")) {
      const [contactId] = contact.split(":");
      const fullContact = findContactById(contactId);
      return fullContact ? fullContact.optIn === false : false;
    }

    return contact.optIn === false;
  };

  if (Array.isArray(msgs)) {
    total = msgs?.reduce((acc, obj) => acc + parseInt(obj?.totalContacts || "0"), 0);

    if (values?.selectedGroupIds && values?.selectedGroupIds.length > 0) {
      const selectedContacts = msgs.reduce((acc, group) => {
        if (group.contacts) {
          return [
            ...acc,
            ...group.contacts.filter(contact => {
              if (typeof contact === "string" && contact.includes(":")) {
                const [contactId] = contact.split(":");
                return values.selectedGroupIds.includes(contactId);
              }
              return values.selectedGroupIds.includes(contact._id);
            })
          ];
        }
        return acc;
      }, []);

      unsubscribe = selectedContacts.filter(isUnsubscribed).length;
      total = selectedContacts.length;
    } else {
      unsubscribe = msgs?.reduce((acc, obj) => acc + (obj?.unsubscribe || 0), 0);
    }
  } else {
    total = msgs?.totalContacts || 0;
    unsubscribe = msgs?.unsubscribe || 0;
  }

  if (values?.numberList) {
    total = values.numberList.length;
    unsubscribe = values.numberList.filter(isUnsubscribed).length;
  }

  if (values?.contacts) {
    total = values.contacts.length;
    unsubscribe = values.contacts.filter(isUnsubscribed).length;
  }

  subscribe = total - unsubscribe;

  return { subscribe, unsubscribe, total };
}
